<div class='score justify-content-center'>
    <div class='text col-2 px-1 text-left'>
        {{ 'CSAT_BAD' | translate }}
    </div>
    @for(score of csatScoreList; track score) {
        <button (click)='selectCsatScore(score)'
            class='{{selectedCsatScore === score ? "selected" : ""}}'
        >
            {{ score }}
        </button>
    }
    <div class='text col-2 px-1 text-right'>
        {{ 'CSAT_GOOD' | translate }}
    </div>
</div>
<div class='textarea-container w-100 mb-4'>
    <textarea
        [ngClass]="{'form-control': !(reportIssueEnabled | async) }"
        placeholder="{{ 'CSAT_TEXTAREA_PLACEHOLDER' | translate }}"
        [(ngModel)]="text"
    ></textarea>
    @if (!(reportIssueEnabled | async)) {
        <div class="form-control-suggestions w-100 p-2">
            @for(boxText of helpBoxText; track boxText) {
                <button
                    class="form-control-suggestions__option mx-1 my-1 p-2"
                    (click)="addTextToTextArea(boxText)"
                >{{ boxText | translate }}
                </button>
            }
        </div>
    }
</div>
<button class="btn mx-auto" [disabled]='disableSendButton'
        title="{{ !disableSendButton ? '' : 'CSAT_SCORE_NOT_SELECTED' | translate }}" (click)='sendCsat()'>Send
</button>

